// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"56":"component---src-pages-dataviz-jsx","223":"commons","279":"component---src-pages-index-jsx"}[chunkId] + "-" + {"56":"3fed503e9a25d80e9020","223":"7709f3d509b933691f2b","279":"38ad1bbabac35b963926"}[chunkId] + ".js";
};